<template>
    <tr>
        <td class="text-left text-body-1">
            <div>{{counter.service}}<span v-if="counter.measure">, {{counter.measure}}</span></div>

            <div class="caption grey--text" style="line-height: 1rem;">
                <span v-if="subtitle">{{subtitle}}</span>
                <template v-if="!hideCheckDate">
                    <div class="caption grey--text">Дата поверки: {{ counter.check ? counter.check: "не указано"}}</div>
                    <v-chip v-if="counter.checkSoon" label color="red" dark small class="mb-3">Скоро поверка счетчика
                    </v-chip>
                </template>
            </div>
        </td>
        <td class="text-right text-body-1">{{counter.prev}}</td>

        <template v-if="counter.canReading">

            <td class="text-right">
                <v-text-field :ref="'counter-'+counter.id" hide-details v-model="current"
                    v-mask="{precision: bit, floatSeparator: true}" outlined dense
                    :append-icon="canUndo ? 'mdi-undo' : ''" @click:append="undo" class="my-class"
                    style="max-width: 120px; margin-left: auto" reverse :class="textFieldClasses" autocomplete="off" />
            </td>

            <td :class="['text-right', 'text-body-1', state.color ? state.color + '--text' : '' ]"
                style="line-height: 1rem">


                <div>{{ current ? consum : '' }}</div>
                <div class="caption" style="line-height: 1rem">{{ state.message }}</div>
            </td>

        </template>

        <template v-else>
            <td colspan="2" class="text-center px-6">
                {{message}}
            </td>
        </template>

    </tr>
</template>

<script>
    import counterMixin from '@/mixins/counterMixin'

    export default {
        mixins: [counterMixin],
        props: {
            hideCheckDate: {
                type: Boolean,
                require: false,
                default: false
            }
        },

        watch: {
            counter() {
                this.current = this.counter.current
            }
        },
        computed: {
            showMessage() {
                return (this.isConsumWarning() || this.isConsumError())
            },
            state() {
                if (this.isConsumError()) {
                    return {
                        message: 'Расход выше максимального',
                        color: 'error'
                    }
                }
                if (this.isConsumWarning()) {
                    return {
                        message: 'Слишком высокий расход',
                        color: 'warning'
                    }
                }
                if (!this.current) {
                    return {
                        message: 'Показания не введены',
                        color: ''
                    }
                }
                return {
                    message: '',
                    color: ''
                }
            },
            textFieldClasses() {
                let classes = ['my-2']
                if (this.isConsumError()) {
                    classes.push('v-input--has-state', 'error--text')
                } else if (this.isConsumWarning()) {
                    classes.push('v-input--has-state', 'warning--text')
                }
                return classes
            }
        },
        created() {
            this.current = this.counter.current
        },
    }
</script>

<style>
    .sg-counter-consum-error {
        -webkit-animation: consum-error 1s infinite;
        /* Safari 4+ */
        -moz-animation: consum-error 1s infinite;
        /* Fx 5+ */
        -o-animation: consum-error 1s infinite;
        /* Opera 12+ */
        animation: consum-error 1s infinite;
        /* IE 10+, Fx 29+ */
    }

    @-webkit-keyframes consum-error {

        0%,
        49% {
            background-color: transparent;
        }

        50%,
        100% {
            background-color: #ffc7c7;
        }
    }
</style>